import React from "react";
import { Link } from "react-router-dom";

const Reaponsivefooter = () => {
  return (
    <div className="res-footer fixed-bottom bg-white border-top responsive-footer">
      <div className="d-flex justify-content-between text-center px-2">
        <div className="footer-cmt pointer-cursor d-flex flex-column align-items-center">
          <Link to="/bsk-home" className="footer-link">
            <i className="fa-solid fa-house fs-5"></i>
            <div className="small">Home</div>
          </Link>
        </div>

        <div className="footer-cmt pointer-cursor d-flex flex-column align-items-center">
          <Link to="/bsk-main-product" className="footer-link">
            <i class="fa-brands fa-product-hunt fs-5"></i>
            <div className="small">Products</div>
          </Link>
        </div>

        <div className="footer-cmt pointer-cursor d-flex flex-column align-items-center">
          <i className="fa-solid fa-magnifying-glass fs-5"></i>
          <div className="small">Search</div>
        </div>

        <div className="footer-cmt pointer-cursor d-flex flex-column align-items-center">
         <Link to="/bsk-user" className="footer-link">
            <i class="fa-regular fa-user fs-5"></i>
            <div className="small">Account</div>
          </Link>
        </div>

        <div className="footer-cmt pointer-cursor d-flex flex-column align-items-center">
          <Link to="/bsk-size-chart" className="footer-link">
            <i class="fa-solid fa-ruler-horizontal fs-5"></i>
            <div className="small">Size Chart</div>
          </Link>
        </div>
      </div>
    </div>
  );
};

export default Reaponsivefooter;
